import { Component, inject } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { RouterLink, Router } from '@angular/router';
import { useNavigationMenu } from '../nav-menu-composable';
import { NavigationMenuItem } from '../nav-menu-item.model';
import { PermissionService } from '../../../../services/permission.service';
import { CHECK_PERMISSIONS } from '@shared/modules/permissions.module';
import { getApiBaseUrl } from '../../../../services/api-base-url';
import Keycloak  from 'keycloak-js';
import { SHARED_MENU_IMPORTS } from '@shared/modules/shared-menu-module';

@Component({
  selector: 'horizontal-bar-menu',
  imports: [MatToolbarModule, MatMenuModule, RouterLink, ...SHARED_MENU_IMPORTS],
  templateUrl: './horizontal-bar-menu.html',
  styles: ``,
})
export class HorizontalBarMenu {
  private readonly router = inject(Router);
  private readonly permissionService = inject(PermissionService);
  protected readonly verifyPermissions = CHECK_PERMISSIONS();
  private readonly keycloak = inject(Keycloak);
  protected readonly hangfireDashboardUrl = `${getApiBaseUrl()}hangfire`;

  readonly items: NavigationMenuItem[] = useNavigationMenu().menuItems;
  navigateTo(route: string) {
    this.router.navigate([route]);
  }

  protected async login(): Promise<void> {
    await this.keycloak.login();
  }

  protected async logout(): Promise<void> {
    await this.keycloak.logout({ redirectUri: window.location.origin });
  }

  protected goToHangfire(): void {
    window.open(this.hangfireDashboardUrl, '_blank', 'noopener,noreferrer');
  }
    
}
